import { render, staticRenderFns } from "./RevenueCodeManagerWidget.vue?vue&type=template&id=23518223"
import script from "./RevenueCodeManagerWidget.vue?vue&type=script&lang=js"
export * from "./RevenueCodeManagerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports